var map = {
	"./adminCrmSystem.store.js": "1406",
	"./adminPartners.store.js": "7f74",
	"./adminPayments.store.js": "0bfe",
	"./ajax.store.js": "ef7c",
	"./audioPlayer.store.js": "7e7d",
	"./auth.store.js": "4f46",
	"./avalon.store.js": "340c",
	"./avalonPage.store.js": "46ed",
	"./bonusCredits.store.js": "5b11",
	"./business.store.js": "86a4",
	"./businessUsers.store.js": "966a",
	"./cart.store.js": "1336",
	"./certificates.store.js": "222b",
	"./chatbots.store.js": "6388",
	"./contacts.store.js": "09fe",
	"./converter.store.js": "75ce",
	"./courses.store.js": "36a5",
	"./crmSystem.store.js": "bd82",
	"./dashboard.store.js": "ab76",
	"./debug.store.js": "5488",
	"./discount.store.js": "3607",
	"./documentation.store.js": "7a1d",
	"./documentflow.store.js": "cae0",
	"./domains.store.js": "eafe",
	"./entitiesFunctions.store.js": "0c41",
	"./evaluation.store.js": "1387",
	"./events.store.js": "9071",
	"./export.store.js": "029d",
	"./faq.store.js": "35d1",
	"./file_browser.store.js": "b366",
	"./finemailer.store.js": "1a19",
	"./fondy.store.js": "8c70",
	"./gamification.store.js": "64d3",
	"./googleMaps.store.js": "a820",
	"./homepage.store.js": "1b7a",
	"./hr.store.js": "4fd8",
	"./import.store.js": "a28c",
	"./leads.store.js": "c29b",
	"./liqpay.store.js": "ac95",
	"./location.store.js": "f959",
	"./messenger.store.js": "f91b",
	"./monobank.store.js": "13da",
	"./news.store.js": "c9e4",
	"./newsletter.store.js": "079d",
	"./notifications.store.js": "cb10",
	"./onboarding.store.js": "9a0c",
	"./orders.store.js": "00e9",
	"./page.store.js": "a6f7",
	"./products.store.js": "fea4",
	"./project_manager.store.js": "af89",
	"./public.store.js": "0f7a",
	"./referral.store.js": "aecf",
	"./settings.store.js": "526c",
	"./socket.store.js": "f6b6",
	"./statistics.store.js": "6733",
	"./storage.store.js": "b793",
	"./stream.store.js": "4aa7",
	"./stripe.store.js": "50ac",
	"./structure.store.js": "abd0",
	"./support.store.js": "8a4c",
	"./templates.store.js": "5d68",
	"./tests.store.js": "e645",
	"./unitedUserActions.store.js": "7769",
	"./upload.store.js": "cb02",
	"./user.store.js": "1b3d",
	"./videoPlayer.store.js": "1c73",
	"./warehouse.store.js": "e6a2",
	"./wayforpay.store.js": "6b22",
	"./wsu_application.store.js": "24a8",
	"./wsu_documents.store.js": "6c27",
	"./wsu_education.store.js": "a73d",
	"./wsu_schedule.store.js": "a797",
	"./wsu_study_profiles.store.js": "112c",
	"./wsu_teacher_profiles.store.js": "90d1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7067";